import React from "react";
import { useState, useEffect } from "react";
import HistoricalDataTable from "../common/HistoricalDataTable.js";
import type { Schema } from "../../amplify/data/resource.js";
import { generateClient } from "aws-amplify/data";

const client = generateClient<Schema>();

const TopStories = () => {
    const [rows, setRows] = useState<Schema["TopNewsStories"]["type"][]>([]);
    const [sortedItems, setSortedItems] = useState({ key: null, direction: 'ascending' });

    useEffect(() => {
        let sub = client.models.TopNewsStories.observeQuery().subscribe({
            next: ({ items }) => {
                let formattedItems = items.map(item => ({
                    ...item,
                    reach: item.reach === 'N/A' ? 'N/A' : (typeof item.reach === 'number' ?
                        item.reach : parseInt(item.reach, 10))
                }))
                .sort(function (a, b) {
                     return new Date(b?.updatedAt) - new Date(a?.updatedAt);
                });
                if (sortedItems.key) {
                    formattedItems = formattedItems.sort((a, b) => {
                        if (a[sortedItems.key] === 'N/A') return 1;
                        if (b[sortedItems.key] === 'N/A') return -1;
                        if (a[sortedItems.key] < b[sortedItems.key]) {
                            return sortedItems.direction === 'ascending' ? -1 : 1;
                        }
                        if (a[sortedItems.key] > b[sortedItems.key]) {
                            return sortedItems.direction === 'ascending' ? 1 : -1;
                        }
                        return 0;
                    });
                }

                formattedItems = formattedItems.map(item => ({
                    ...item,
                    reach: item.reach === 'N/A' ? 'N/A' : item.reach.toLocaleString()
                }));

                setRows(formattedItems);
            }
        });
        return () => sub.unsubscribe();
    }, [sortedItems]);

    let requestSort = (key) => {
        let direction = 'ascending';
        if (sortedItems.key === key && sortedItems.direction === 'ascending') {
            direction = 'descending';
        }
        setSortedItems({ key, direction });
    };


    return (
        <div className="dashboard">
            <h1>Top Stories</h1>
            <p>
                Media coverage of contract with broad visibility and/or influence in key
                markets.
            </p>
            <HistoricalDataTable
                headers={["Date", "Article", "Source", "Reach", "Sentiment"]}
                rows={rows}
                fields={["date", "article", "source", "reach", "sentiment"]}
                filterableFields={["Date", "Source", "Sentiment"]}
                requestSort={requestSort}
            />
        </div>
    );
};

export default TopStories;
